<template>
    <v-select
        :items="skillLevels"
        @input="$emit('input', $event)"
        :value="value"
        label="Skill Level"
        class="soli-round"
        item-text="name"
        item-value="id"
        return-object
        outlined
        multiple
        dense
        :rules="rules"
    ></v-select>
</template>

<script>
export default {
    props: ["value", "rules"],
    data() {
        return {
            skillLevels: null,
        };
    },
    mounted() {
        axios
            .get("/api/instruments/skill-levels")
            .then((resp) => (this.skillLevels = resp.data));
    },
};
</script>
